import { memo, useRef } from "react";
import { useSnapFeed } from "./hooks/useSnapFeed";
import { FullScreenNav } from "../FullScreenNav";
import "./PreviewFeed.scss";

interface IPreviewFeed {
  withSnap?: boolean;
  children: React.ReactNode;
}

export const PreviewFeed = memo(({ children, withSnap }: IPreviewFeed) => {
  const previewFeedRef = useRef<HTMLDivElement | null>(null);

  useSnapFeed({ previewFeedRef, withSnap });

  return (
    <>
      <div className="previewFeed" ref={previewFeedRef}>
        {children}
      </div>
      <FullScreenNav previewFeedRef={previewFeedRef} />
    </>
  );
});
